import { isEqual } from "lodash"

export const PHONE_PATTERN = /^\+?(?=(?:\D*\d){5,17}\D*$)[0-9 ()\-.]{5,32}$/
export const createLeadDraft = lead => ({
  clubName: lead.clubName || "", firstName: lead.firstName || "", lastName: lead.lastName || "",
  jobTitle: lead.jobTitle || "", email: lead.email || "", phone: lead.phone || "",
  sports: [...(lead.sports || [])], noCourts: lead.noCourts == null ? "" : String(lead.noCourts),
  location: lead.location ? { ...lead.location } : null, status: lead.status || "",
})
export const leadPayload = draft => ({ ...draft, noCourts: Number(draft.noCourts) })
export const hasLeadChanges = (lead, draft) => !leadMatchesDraft(lead, draft)

export const validateLeadDraft = draft => {
  const errors = {}
  for (const field of ["clubName", "firstName", "lastName"]) {
    if (!draft[field].trim()) errors[field] = "This field is required."
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(draft.email)) errors.email = "Enter a valid email address."
  if (!PHONE_PATTERN.test(draft.phone)) errors.phone = "Use 5–17 digits, with an optional +, spaces, parentheses, dots or hyphens (maximum 32 characters)."
  if (draft.noCourts === "" || !Number.isInteger(Number(draft.noCourts)) || Number(draft.noCourts) < 0) {
    errors.noCourts = "Enter a whole number of courts, zero or greater."
  }
  if (!draft.location?.country || !(draft.location?.name || draft.location?.city)) errors.location = "Select a location in the chosen country."
  if (!["pending", "closed"].includes(draft.status)) errors.status = "Select Pending or Closed."
  return errors
}

// Compare the editable fields only; API-generated metadata must not cause a mismatch.
export const leadMatchesDraft = (lead, draft) => {
  const actual = createLeadDraft(lead)
  return Object.keys(draft).every(key => key === "sports"
    ? isEqual([...actual.sports].sort(), [...draft.sports].sort())
    : key === "noCourts"
      ? (actual.noCourts === "" || draft.noCourts === "" ? actual.noCourts === draft.noCourts
        : Number(actual.noCourts) === Number(draft.noCourts))
      : isEqual(actual[key], draft[key]))
}
